import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import { useFormikContext } from 'formik'

const StyledSelect = styled(Select)`
  .react-select__control {
    background-color: var(--colour-surface-input);
    border: 1px solid var(--colour-border-input);
    border-radius: var(--radius-4);
    font-family: var(--font-sans-serif-light);
    font-size: var(--font-size-input);
    line-height: var(--line-height-input);
    padding: var(--grid-8) var(--padding-input-x);
    width: 100%;
    outline: none;
    transition: border 0.3s ease-in;
  }

  .react-select__input-container {
    padding: 0;
    margin: 0;
  }

  .react-select__control--is-focused,
  .react-select__control:hover {
    border: 1px solid var(--colour-border-input-focus);
    outline: none;
    box-shadow: none;
  }

  .react-select__value-container {
    padding: 0;
  }

  .react-select__indicator-separator {
    display: none;
  }
  

  .react-select__dropdown-indicator {
    color: var(--colour-text-secondary);
    padding-right: 0;
  }

  .react-select__menu {
    border: 1px solid var(--colour-border-input);
    border-radius: var(--radius-4);
    box-shadow: none;
    font-family: var(--font-sans-serif-light);
    font-size: var(--font-size-input);
    line-height: var(--line-height-input);
    width: 100%;
  }

  .react-select__option {
    padding: var(--grid-8);
    padding-left: var(--grid-16);
  }

  .react-select__option--is-selected {
    background-color: var(--colour-border-focused);
    color: var(--light-neutral-100);
  }
`

interface DropDownSelectOption {
  value: string
  label: string
}

interface DropdownProps {
  name: string
  options: DropDownSelectOption[]
  selected: string
  onSelect: (option: string) => void
  disabled?: boolean
  placeholder?: string
}

export const DSDropdown = ({ name, options, selected, onSelect, disabled, placeholder }: DropdownProps) => {
  const { setFieldValue } = useFormikContext()
  const selectedOption = options.find((option) => option.value === selected)
  const handleChange = async (option: { value: string; label: string }) => {
    await setFieldValue(name, option.value)
    onSelect(option.value)
  }

  return (
    <StyledSelect
      classNamePrefix="react-select"
      defaultValue={selectedOption}
      isDisabled={disabled}
      name={name}
      // @ts-expect-error - react-select types want unknown
      onChange={handleChange}
      options={options}
      placeholder={placeholder}
    />
  )
}
